(function() {
  function mod(index, total) {
    return ((index % total) + total) % total;
  }

  function initAgrasSlider(container) {
    if (!container || container.dataset.agrasInitialized === 'true') {
      return;
    }
    container.dataset.agrasInitialized = 'true';

    var track = container.querySelector('.agras-slider__track');
    var slides = container.querySelectorAll('.agras-slider__slide');
    var prevButton = container.querySelector('[data-agras-prev]');
    var nextButton = container.querySelector('[data-agras-next]');
    var jumpButtons = container.querySelectorAll('[data-agras-jump]');
    var autoPlayEnabled = container.dataset.agrasAutoplay === 'true';
    var autoPlaySpeed = parseInt(container.dataset.agrasAutoplaySpeed, 10);
    if (isNaN(autoPlaySpeed) || autoPlaySpeed < 1000) {
      autoPlaySpeed = 5000;
    }
    var titleNodes = {
      prev: container.querySelector('[data-agras-title-text="prev"]'),
      current: container.querySelector('[data-agras-title-text="current"]'),
      next: container.querySelector('[data-agras-title-text="next"]')
    };

    if (!track || !slides.length || typeof Flickity === 'undefined') {
      return;
    }

    var titles = Array.prototype.map.call(slides, function(slide, index) {
      var text = (slide.getAttribute('data-nav-title') || '').trim();
      return text || ('Slide ' + (index + 1));
    });

    var lastActiveIndex = 0;
    var titleInited = false;
    var forcedDirection = null;
    function ensureTitleRoller(node, text) {
      var roller = node.querySelector('.agras-title-roller');
      if (!roller) {
        roller = document.createElement('span');
        roller.className = 'agras-title-roller';
        roller.innerHTML = '<span></span><span></span>';
        node.textContent = '';
        node.appendChild(roller);
      }

      var lines = roller.querySelectorAll('span');
      lines[0].textContent = text;
      lines[1].textContent = text;
      roller.style.transition = 'none';
      roller.style.transform = 'translateY(0)';
      return roller;
    }

    function rollTitleNode(node, newText, goingForward) {
      var roller = node.querySelector('.agras-title-roller') || ensureTitleRoller(node, newText);
      var lines = roller.querySelectorAll('span');
      var currentText = lines[0].textContent;
      var computedStyle = window.getComputedStyle(node);
      var rowHeight = parseFloat(computedStyle.lineHeight);
      if (isNaN(rowHeight) || rowHeight <= 0) {
        rowHeight = node.getBoundingClientRect().height || 0;
      }
      var lockedWidth = node.getBoundingClientRect().width;

      if (currentText === newText) {
        return;
      }

      // Keep width stable during animation to avoid short text "jumping" toward center.
      node.style.width = lockedWidth + 'px';

      if (goingForward) {
        lines[0].textContent = currentText;
        lines[1].textContent = newText;
        roller.style.transition = 'none';
        roller.style.transform = 'translateY(0)';
        requestAnimationFrame(function() {
          roller.style.transition = 'transform 0.42s cubic-bezier(0.22, 0.61, 0.36, 1)';
          roller.style.transform = 'translateY(-' + rowHeight + 'px)';
        });
      } else {
        lines[0].textContent = newText;
        lines[1].textContent = currentText;
        roller.style.transition = 'none';
        roller.style.transform = 'translateY(-' + rowHeight + 'px)';
        requestAnimationFrame(function() {
          roller.style.transition = 'transform 0.42s cubic-bezier(0.22, 0.61, 0.36, 1)';
          roller.style.transform = 'translateY(0)';
        });
      }

      window.setTimeout(function() {
        lines[0].textContent = newText;
        lines[1].textContent = newText;
        roller.style.transition = 'none';
        roller.style.transform = 'translateY(0)';
        node.style.width = '';
      }, 440);
    }

    function updateTitleStack(activeIndex) {
      var total = titles.length;
      var prevIndex = mod(activeIndex - 1, total);
      var nextIndex = mod(activeIndex + 1, total);

      container.querySelector('[data-agras-jump="prev"]').setAttribute('data-target-index', String(prevIndex));
      container.querySelector('[data-agras-jump="current"]').setAttribute('data-target-index', String(activeIndex));
      container.querySelector('[data-agras-jump="next"]').setAttribute('data-target-index', String(nextIndex));

      // Update nav color based on current slide
      var activeSlide = slides[activeIndex];
      if (activeSlide) {
        var headerWrapper = document.getElementById('HeaderWrapper');
        var siteHeader = document.getElementById('SiteHeader');
        // Only alter the header if it is set to overlay mode
        if (headerWrapper && siteHeader && siteHeader.dataset.overlay === 'true') {
          var headerStyle = activeSlide.getAttribute('data-header-style');
          
          // Note: When the header is "stuck" (sticky), the theme handles its own colors
          if (!siteHeader.classList.contains('site-header--stuck')) {
            if (headerStyle === 'dark') {
              headerWrapper.classList.remove('is-light');
            } else {
              headerWrapper.classList.add('is-light');
            }
          }
          
          if (headerStyle === 'dark') {
            headerWrapper.dataset.agrasHeaderOverridden = 'dark';
          } else {
            headerWrapper.dataset.agrasHeaderOverridden = 'light';
          }
        }

        var navColor = window.getComputedStyle(activeSlide).getPropertyValue('--slide-nav-color').trim();
        if (navColor) {
          var titlesContainer = container.querySelector('.agras-slider__titles');
          if (titlesContainer) {
            titlesContainer.style.setProperty('--current-nav-color', navColor);
          }
        }
      }

      if (!titleInited) {
        titleInited = true;
        lastActiveIndex = activeIndex;
        ensureTitleRoller(titleNodes.prev, titles[prevIndex]);
        ensureTitleRoller(titleNodes.current, titles[activeIndex]);
        ensureTitleRoller(titleNodes.next, titles[nextIndex]);
        return;
      }

      var goingForward;
      if (forcedDirection !== null) {
        goingForward = forcedDirection;
        forcedDirection = null;
      } else {
        goingForward = mod(activeIndex - lastActiveIndex, total) <= Math.floor(total / 2);
      }
      lastActiveIndex = activeIndex;

      rollTitleNode(titleNodes.prev, titles[prevIndex], goingForward);
      rollTitleNode(titleNodes.current, titles[activeIndex], goingForward);
      rollTitleNode(titleNodes.next, titles[nextIndex], goingForward);
    }

    var slider = new Flickity(track, {
      prevNextButtons: false,
      pageDots: true,
      wrapAround: true,
      setGallerySize: false,
      fade: true,
      adaptiveHeight: false,
      draggable: slides.length > 1,
      imagesLoaded: true,
      autoPlay: autoPlayEnabled ? autoPlaySpeed : false,
      pauseAutoPlayOnHover: true
    });

    updateTitleStack(0);

    slider.on('change', function(index) {
      updateTitleStack(index);
    });

    if (prevButton) {
      prevButton.addEventListener('click', function() {
        forcedDirection = false;
        slider.previous();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function() {
        forcedDirection = true;
        slider.next();
      });
    }

    jumpButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var jumpType = button.getAttribute('data-agras-jump');
        if (jumpType === 'next') {
          forcedDirection = true;
        } else if (jumpType === 'prev') {
          forcedDirection = false;
        }

        var targetIndex = parseInt(button.getAttribute('data-target-index'), 10);
        if (!isNaN(targetIndex)) {
          slider.select(targetIndex);
        }
      });
    });

  }

  // Note: transparent header is applied via synchronous inline script in the section liquid,
  // before theme.js deferred init reads the header's data-overlay attribute.

  function scanAndInit(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-agras-slider]').forEach(function(node) {
      initAgrasSlider(node);
    });
  }

  if (!window.__agrasSliderEventsBound) {
    document.addEventListener('shopify:section:load', function(evt) {
      if (evt.target) {
        scanAndInit(evt.target);
      }
    });

    window.__agrasSliderEventsBound = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scanAndInit(document);
    });
  } else {
    scanAndInit(document);
  }
})();
